import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FileItem, FileUploader } from 'ng2-file-upload';
import { EMPTY, Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ToastService } from '@libs/src/toast/toast.service';

import { UPLOAD_IMAGE_URL } from '@main-client/src/app/upload/upload.helper';

import get from 'lodash-es/get';

@Injectable({ providedIn: 'root' })
export class UploadService {
  constructor(
    private http: HttpClient,
    private toastService: ToastService,
  ) {}

  private _getApiUrl(documentType: string): string {
    return get(UPLOAD_IMAGE_URL, documentType);
  }

  removeImage(documentType: string, customUploadUrl?: string): Observable<any> {
    const url = this._getApiUrl(documentType);
    return this.http.delete(customUploadUrl || url);
  }

  uploader({
    customUploadUrl,
    documentType,
  }: {
    customUploadUrl?: string;
    documentType: string;
  }): FileUploader {
    const uploadUrl = this._getApiUrl(documentType);
    return new FileUploader({ url: customUploadUrl || uploadUrl });
  }

  dataURItoFile(dataURI: string, fileName: string): File {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob: any = new Blob([ab], { type: mimeString });
    blob.lastModifiedDate = new Date();
    blob.name = fileName;
    return blob as File;
  }

  initUploaderWithCallback(
    documentType: string,
    callback: (imageUrl: string) => any,
  ) {
    const uploader = this.uploader({ documentType });
    uploader.onAfterAddingFile = (fileItem: FileItem) => {
      this.uploadImage(documentType, fileItem._file)
        .pipe(
          catchError((responseError: { status: number; error: any }) => {
            this.toastService.showError(responseError.error.message);
            return EMPTY;
          }),
        )
        .subscribe((response: { imageUrl: string }) =>
          callback(response.imageUrl),
        );
    };
    return uploader;
  }

  uploadImage(documentType: string, file: File, customUploadUrl?: string) {
    const formData = new FormData();
    formData.append('file', file);
    return this.http
      .post(
        customUploadUrl || (UPLOAD_IMAGE_URL as any)[documentType],
        formData,
      )
      .pipe(
        catchError((responseError: { status: number; error: any }) => {
          if (200 === responseError.status) {
            return of({
              imageUrl: responseError.error.text,
            });
          }
          return throwError(responseError);
        }),
      );
  }
}
